

 //--
import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";

 const AddSection=(data:any):Promise<any>=>request({
  url:ApiURL.Command.AddSection,
  method: RequestType.POST,
  data
 });
 const UpdateSection=(data:any):Promise<any>=>request({
  url:ApiURL.Command.UpdateSection+"/"+data.sectionId,
  method: RequestType.PUT,
  data
 });
 const DeleteSection=(data:any):Promise<any>=>request({
  url:ApiURL.Command.DeleteSection + "/" + data.sectionId,
  method: RequestType.DELETE,
 });
 const CreateTemplate=(data:any):Promise<any>=>request({
  url:ApiURL.Command.CreateTemplate,
  method: RequestType.POST,
  data
 });
 const DeleteTemplate=(data:any):Promise<any>=>request({
  url:ApiURL.Command.DeleteTemplate + "/" + data.templateId,
  method: RequestType.DELETE,
 });
 
const EmailTemplateBuilderCommand = {
  AddSection, 
  UpdateSection,
  DeleteSection,
  CreateTemplate,
  DeleteTemplate
};

export default EmailTemplateBuilderCommand;
